import React from "react";
import PropTypes from "prop-types";

import { MyDraggable as Draggable } from "../../components/Core";
import HoverBar from "../../components/HoverBar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "reactstrap";
import { generateStyle, l, setOverLay } from "../../functions";
import Icon from "../../components/Icons";

import { connect } from "react-redux";
import isEqual from "lodash/isEqual";

const mapStateToProps = (state) => {
  return {
    currentLang: state.rootReducer.currentLang || 1,
    settings: state.rootReducer?.appearanceSettings || {},
  };
};

class ProductQuantity extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  shouldComponentUpdate(nextProp, nextState) {
    if (
      !isEqual(this.props?.payload, nextProp?.payload) ||
      !isEqual(this.props?.settings, nextProp?.settings)
    ) {
      return true;
    }

    return false;
  }

  _initQty = (preview, blockPreview = false) => {
    let { payload, parentID } = this.props;

    if (blockPreview || payload === null) {
      payload = this.props.options.payload;
      parentID = "root";
    }

    const { currentDesign } = payload.datas || {};

    let QtyLabel = payload.datas["QtyLabel"] || "";

    if (payload.datas && payload.datas["QtyLabel_" + this.props.currentLang])
      QtyLabel = payload.datas["QtyLabel_" + this.props.currentLang];

    const cssSettings = generateStyle(payload, "container");
    const cssSettingsText = generateStyle(payload, "text", "body");

    if (parentID === "root" && !blockPreview)
      return (
        <Container fluid={payload.fullContainer} style={cssSettings}>
          {setOverLay(payload)}
          <Row>
            <Col xs={12} className="fullcol">
              <div className={`qtyselector layout${currentDesign}`}>
                {!preview && <div className="overlay"></div>}
                {QtyLabel && <span style={cssSettingsText}>{QtyLabel}</span>}
                <div className="qty-box">
                  <div className="button-container">
                    <button className="qty-minus" type="button" value="-">
                      <FontAwesomeIcon
                        icon={[
                          "fas",
                          currentDesign && currentDesign === 3
                            ? "angle-down"
                            : "minus",
                        ]}
                      />
                    </button>
                    <input
                      type="text"
                      name="qty"
                      className="qty input-text"
                      value="0"
                      readOnly
                    />
                    <button className="qty-plus" type="button" value="+">
                      <FontAwesomeIcon
                        icon={[
                          "fas",
                          currentDesign && currentDesign === 3
                            ? "angle-up"
                            : "plus",
                        ]}
                      />
                    </button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      );
    else
      return (
        <div style={cssSettings}>
          {setOverLay(payload)}
          <div className={`qtyselector layout${currentDesign}`}>
            {!preview && <div className="overlay"></div>}
            {QtyLabel && <span style={cssSettingsText}>{QtyLabel}</span>}
            <div className="qty-box">
              <div className="button-container">
                <button className="qty-minus" type="button">
                  <FontAwesomeIcon
                    icon={[
                      "fas",
                      currentDesign && currentDesign === 3
                        ? "angle-down"
                        : "minus",
                    ]}
                  />
                </button>
                <input
                  type="text"
                  name="qty"
                  className="qty input-text"
                  value="0"
                  readOnly
                />
                <button className="qty-plus" type="button">
                  <FontAwesomeIcon
                    icon={[
                      "fas",
                      currentDesign && currentDesign === 3
                        ? "angle-up"
                        : "plus",
                    ]}
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      );
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          {(options.showPreview && this._initQty(false, true)) || (
            <span className="dragger">
              {(Array.isArray(rest.icon) && (
                <FontAwesomeIcon icon={rest.icon} />
              )) || <Icon icon={rest.icon} />}
              <span>{l(rest.name)}</span>
            </span>
          )}
        </Draggable>
      );
    }

    if (showPreview) {
      return <div>{this._initQty(true, false)}</div>;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._initQty()}
      </Draggable>
    );
  }
}

ProductQuantity.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(ProductQuantity);
